import * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../../feature'
import { getEdgeDataDefinition, getNodeDataDefinition } from '../elements'
import type { Manager } from '../manager'

export const addNodeToCytoscape = store.effects.create(
  (feature: Feature, manager: Manager) =>
    feature.actions.addNode.success.observe().pipe(
      rxjs.map(
        ({
          data: {
            request: { parentId, chartId },
            response: { node },
          },
        }) => {
          const cy = manager.getInstance({ chartId })
          if (!cy) {
            return
          }
          cy.add({ data: getNodeDataDefinition(node) })
          if (parentId) {
            cy.add({
              data: getEdgeDataDefinition({
                childId: ents.core.display.tree.Node.Id.get(node),
                parentId,
              }),
            })
          }
          manager.resetLayout({ chartId: chartId })
        },
      ),
      rxjs.ignoreElements(),
    ),
)
